import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { HotToastService } from '@ngxpert/hot-toast';
import { BehaviorSubject, Observable } from 'rxjs';

import { CommonService } from '../services/common.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  getdataToken: any;
  tokenstring: any;
  public currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;
  userData: any;
  modules: Array<any> = [];
  decodeToken: any;
  getModule: any;

  private LoginData: BehaviorSubject<any> = new BehaviorSubject<any>(null) ;
  public LoginResponse:Observable<any> = this.LoginData.asObservable();

  constructor(
    private commonService: CommonService,
    private toast: HotToastService,
    private router: Router
  ) {
    this.currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser') || 'null'));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  // isAuthenticate(): boolean {
  //   const userData = localStorage.getItem('currentUser');
  //   if (userData && userData.length > 0) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  cUser: any;
  loginAction(formData: any) {
    this.commonService.checkLogin(formData).subscribe(
      (res) => {
        if (res.message == 'Login Successes') {
          localStorage.setItem("Email", formData.emailID.split("@")[0])
          this.setToken(res);
        } else {
          this.LoginData.next(false);
          this.toast.error('invalid credentials');
        }
      },
      (err) => {
        this.LoginData.next(false);
        if (err == '') {
          this.LoginData.next(false);
          this.toast.error('invalid credentials');
        }
      }
    );
  }

  accountMatch(allowedAccounts: any) {
    let isMatch = false;
    let module_items: any = [];
    let conString = allowedAccounts.toString();
    let modules_value = JSON.parse(localStorage.getItem('module_item') || 'null');
    if (typeof modules_value === 'object') {

      modules_value.forEach((element: any) => {
        let module_item = element.slice(2).toLowerCase();
        module_items.push(module_item);
      });
    }
    else {
      let module_value = modules_value.slice(2).toLowerCase();
      module_items.push(module_value);
    }
    if (module_items.includes(conString)) {
      isMatch = true;
    }
    return isMatch;
  }

  setToken(data: any) { 
    this.LoginData.next(true);
    const getdataToken = data['jwtToken']
    const decodeToken = JSON.parse(atob(getdataToken.split('.')[1]));
    const cUser = data['currentUser'].firstName + " " + data['currentUser'].lastName;
    localStorage.setItem('uName', JSON.stringify(cUser));
    localStorage.setItem('currentUser', JSON.stringify(getdataToken));
    localStorage.setItem('userData', JSON.stringify(decodeToken));
    localStorage.setItem('module_item', JSON.stringify(decodeToken['Module']));
    localStorage.setItem('exp', decodeToken["exp"]);

    this.currentUserSubject.next(getdataToken);

    this.router.navigate(['project/list']);
    this.toast.success("Welcome back to QMigrator");
  }

  isAuthenticate() { 
    const userData = localStorage.getItem('currentUser');
    if (userData && userData.length > 0) {
      const exp = localStorage.getItem('exp');
      const expValue = exp ? Number(exp) : 0;
      const expDate = new Date(expValue * 1000);
      if (new Date() > expDate) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }

}
